


































































































import { Component, Mixins } from "vue-mixin-decorator";
import { Prop, Watch } from "vue-property-decorator";
import SButton from "@/app/basic/common/components/SButton.vue";
import { StoreUseData } from "@/@types/store";
import {
  createRectangle,
  createSize
} from "@/app/core/utility/CoordinateUtility";
import ComponentVue from "@/app/core/window/ComponentVue";
import CardSearchCountChooser from "@/app/basic/common/components/CardSearchCountChooser.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import { CardMeta } from "@/@types/gameObject";
import CardComponent from "@/app/basic/card/CardComponent.vue";
import VueEvent from "@/app/core/decorator/VueEvent";

export type CardCountInfo = {
  id: string;
  count: number;
};

@Component({
  components: {
    CardSearchCountChooser,
    SButton,
    CardComponent,
    CtrlButton
  }
})
export default class CardChooserComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private title!: string;

  @Prop({ type: Array, required: true })
  private cardList!: StoreUseData<CardMeta>[];

  // selectedCardIdList
  @Prop({ type: Array, required: true })
  private selectedCardList!: CardCountInfo[];

  // cardDeckName
  @Prop({ type: String, required: true })
  private cardDeckName!: string;
  private cardDeckNameVolatile: string = "";
  @Watch("cardDeckName", { immediate: true })
  private onChangeCardDeckName(value: string) {
    this.cardDeckNameVolatile = value;
  }
  @Watch("cardDeckNameVolatile")
  private onChangeCardDeckNameVolatile(value: string) {
    this.$emit("update:cardDeckName", value);
  }

  private hoverCardId: string | null = null;

  private searchText: string = "";
  private searchCountList: string[] = ["0", "1", "2", "3", "4", "more"];
  private targetCount: number = 1;

  private get useCardList() {
    const regExp = this.searchText ? new RegExp(this.searchText) : null;
    return this.cardList.filter(c => {
      if (regExp) {
        const name = c.data!.name;
        if (!name.match(regExp)) return false;
      }
      const count = this.getSelectedCount(c.id!);
      return (
        (count > 4 && this.searchCountList.indexOf("more") > -1) ||
        this.searchCountList.indexOf(count.toString(10)) > -1
      );
    });
  }

  @VueEvent
  private getCardSize(cardMeta: CardMeta) {
    return createSize(cardMeta.width, cardMeta.height);
  }

  @VueEvent
  private setCardCount() {
    this.useCardList.forEach(c => {
      const scIndex = this.selectedCardList.findIndex(sc => sc.id === c.id);
      if (scIndex === -1) {
        // 見つからなかった
        if (this.targetCount > 0) {
          this.selectedCardList.push({
            id: c.id!,
            count: this.targetCount
          });
        } else {
          // Nothing.
        }
      } else {
        // 見つかった
        if (this.targetCount > 0) {
          this.selectedCardList[scIndex].count = this.targetCount;
        } else {
          // Nothing.
          this.selectedCardList.splice(scIndex, 1);
        }
      }
    });
  }

  @VueEvent
  private getSelectedCount(cardId: string): number {
    const info = this.selectedCardList.filter(c => c.id === cardId)[0];
    return info ? info.count : 0;
  }

  @VueEvent
  private onPlusCard(cardMeta: StoreUseData<CardMeta>) {
    const findIdx = this.selectedCardList.findIndex(c => c.id === cardMeta.id);
    if (findIdx === -1) {
      this.selectedCardList.push({
        id: cardMeta.id!,
        count: 1
      });
    } else {
      this.selectedCardList[findIdx].count++;
    }
  }

  @VueEvent
  private onMinusCard(cardMeta: StoreUseData<CardMeta>) {
    const findIdx = this.selectedCardList.findIndex(c => c.id === cardMeta.id);
    if (findIdx === -1) return;

    const info = this.selectedCardList[findIdx];
    if (info.count > 1) info.count--;
    else this.selectedCardList.splice(findIdx, 1);
  }

  @VueEvent
  private onHoverCard(
    card: StoreUseData<CardMeta>,
    isHover: boolean,
    elm: HTMLElement
  ) {
    this.hoverCardId = isHover ? card.id! : null;
    const rect = elm.getBoundingClientRect();
    const r = createRectangle(rect.x, rect.y, rect.width, rect.height);
    this.$emit("hover-card", card, isHover, r);
  }
}
